import { render } from "./PersonModal.vue?vue&type=template&id=20fdca14"
import script from "./PersonModal.vue?vue&type=script&lang=js"
export * from "./PersonModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/aksoftware/software/haushaltsbuchfrontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__